module.exports = __webpack_public_path__ + "img/CATEGORY ICON-06.4e0ac1eb.png";